import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import clsx from 'classnames';
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption, ComboboxButton, Label, Field } from "@headlessui/react";
import { FaChevronDown, FaCheck } from "react-icons/fa6";
import { Store, useStore } from "../store";
import { countriesNumData } from "../utils/geo";

const Country = () => {
  const { t } = useTranslation();

  const userData = useStore((state: Store) => state.userData)
  const setUserData = useStore((state: Store) => state.setUserData)
  const { country: selectedCountry } = userData;

  const [query, setQuery] = useState('')

  const handleChange = (countryCode: string) => {
    setUserData({ ...userData, country: countryCode })

    axios.patch(`/users/${userData.id}/country`, { country: countryCode })
      .catch((err) => console.log(err))
  };

  const countries = countriesNumData
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(country => ({ code: country.code, name: t(`country.${country.code}`) }))

  const filteredCountries =
    query === ''
      ? countries
      : countries.filter((c) => {
        return c.name.toLowerCase().includes(query.toLowerCase())
      })

  return (
    <Field>
        <Label className="block mb-2 text-center">{t('country.label')}</Label>

        <Combobox
          name="country"
          value={selectedCountry}
          onChange={(value) => handleChange(value)}
          onClose={() => setQuery('')}
          immediate
        >
          <div className="relative">
            <ComboboxInput
              className={clsx(
                'rounded-full border-none bg-black/15 py-1.5 px-8 text-sm/6 text-white text-center w-[250px]',
                'focus:not-data-focus:outline-none data-focus:outline-2 data-focus:-outline-offset-2 data-focus:outline-white/25'
              )}
              id="country-select"
              name="country"
              displayValue={(country) => country ? t(`country.${country}`) : ""}
              placeholder={t('country.placeholder')}
              onChange={(event) => setQuery(event.target.value)}
            />
            <ComboboxButton className="group absolute inset-y-0 right-0 px-2.5">
              <FaChevronDown className="size-4 fill-white/60 group-data-hover:fill-white"/>
            </ComboboxButton>
          </div>

          <ComboboxOptions
            anchor={{ to: 'bottom', gap: '8px', padding: '8px' }}
            transition
            className={clsx(
              'w-(--input-width) backdrop-blur-md text-center rounded-xl border border-black/15 bg-black/15 p-1',
              'empty:invisible transition duration-100 ease-in data-leave:data-closed:opacity-0'
            )}
          >
            {filteredCountries.map((country) => (
              <ComboboxOption
                key={country.code}
                value={country.code}
                className="group flex justify-center items-center cursor-pointer gap-2 rounded-lg px-3 my-2 select-none data-focus:bg-white/10"
              >
                <FaCheck className="hidden size-4 fill-white group-data-selected:block"/>
                <div className="text-sm/6 text-white ">{t(`country.${country.code}`)}</div>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        </Combobox>
    </Field>
  )
};

export default Country;